import { css, cva } from '@/styled-system/css';

export const topContainerStyles = css.raw({
  backgroundColor: 'blue.100',
  display: 'flex',
  flexDirection: { base: 'column', lg: 'row' },
  gap: { base: '0', lg: '600' },
  alignItems: 'center',
  marginTop: '-32px',
  padding: {
    base: '{spacing.1000} {spacing.400} {spacing.600} ',
    lg: '{spacing.1000} {spacing.1200}',
    xl: '{spacing.1000} 154px',
  },
  // Overrides PageWizard margin
  position: 'relative',
  left: '50%',
  right: '50%',
  marginLeft: '-50vw',
  marginRight: '-50vw',
  width: '100vw',
});

export const graphContainerStyles = css.raw({
  backgroundColor: 'white',
  borderRadius: '200',
  paddingBottom: '400',
  maxWidth: '400px',
  width: '100%',
});

export const rightContainerStyles = css.raw({
  width: { base: '100%', lg: '50%' },
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
});

export const mobileButtonGroupStyles = css.raw({
  margin: '{spacing.600} 0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: '600',
  width: '100%',
});

export const cardContainerStyles = css.raw({
  marginTop: '1000',
  display: 'grid',
  gridTemplateColumns: { base: '1fr', lg: '1fr 1fr' },
  gap: '600',
  alignItems: 'stretch',
});

export const cardStyles = css.raw({
  borderRadius: '500',
  background: 'white',
  boxShadow: '{sizes.zero} {sizes.100} {radii.500} {radii.zero} {colors.transparent.black-30}',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const cardAvatarStyles = cva({
  base: {
    boxShadow: 'none',
    marginTop: '600',
    marginBottom: '400',
  },
  variants: {
    isPremium: {
      true: {
        backgroundColor: 'yellow.100',
      },
      false: {
        backgroundColor: 'legacy.coolGray.100',
      },
    },
  },
});

export const cardBodyStyles = css.raw({
  backgroundColor: 'legacy.coolGray.100',
  width: '100%',
  padding: '600',
  height: { base: 'auto', lg: '100%' },
});
